import { Dispatch, SetStateAction, useEffect, useState } from "react";

const initializeState =
  <T>(key: string, initialValue: T) =>
  (): T => {
    try {
      const item = localStorage.getItem(key);
      if (item) {
        return JSON.parse(item).state ?? initialValue;
      }
    } catch (e) {
      // nothing to do here
    }
    return initialValue;
  };

const usePersistedState = <T>(
  key: string,
  initialValue: T,
): [T, Dispatch<SetStateAction<T>>] => {
  const [state, setState] = useState<T>(initializeState<T>(key, initialValue));
  useEffect(() => {
    try {
      if (state === null) {
        localStorage.removeItem(key);
      } else {
        localStorage.setItem(key, JSON.stringify({ state }));
      }
    } catch (e) {
      // nothing to do here
    }
  }, [state, key]);
  return [state, setState];
};

export default usePersistedState;
